import type { CityConfig } from "../city-template/types";

export const sikestonMOConfig: CityConfig = {
  city: "Sikeston",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "sikeston-mo",
  route: "/cities/sikeston-mo",
  title: "Emergency Passport Sikeston, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Sikeston, MO — as fast as 24 hours. Serving Scott County and the Missouri Bootheel region. A+ BBB rated registered State Dept. courier serving Sikeston, Charleston, New Madrid, and southeast Missouri. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Sikeston, MO",
  heroSubtitle: "Bootheel business trip to Brazil in two weeks and your passport expired? Southeast Missouri family cruise from New Orleans next week? Lambert's Café road trip turns international — need passport documents fast? We help Sikeston residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Sikeston%20Missouri%20Scott%20County%20downtown%20district%20historic%20Main%20Street%20Lamberts%20Cafe%20throwed%20rolls%20landmark%20agricultural%20hub%20Missouri%20Bootheel%20region%20flat%20fertile%20farmland%20cotton%20fields%20historic%20railroad%20depot%20southern%20Missouri%20charm%20professional%20drone%20photography%20Heartland%20agriculture%20and%20rural%20community%20heritage&width=1800&height=700&seq=sikeston-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Sikeston Missouri downtown Bootheel region agricultural hub with Lambert's Cafe landmark at golden hour",
  geoPosition: "36.8767;-89.5856",
  geoPlacename: "Sikeston, Missouri",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 475 miles north of Sikeston via I-57",
  },
  nearbyCitiesZips: [
    { name: "Sikeston", zips: "63801" },
    { name: "Charleston", zips: "63834" },
    { name: "New Madrid", zips: "63869" },
    { name: "Dexter", zips: "63841" },
    { name: "Cape Girardeau", zips: "63701, 63703" },
    { name: "East Prairie", zips: "63845" },
    { name: "Portageville", zips: "63873" },
    { name: "Caruthersville", zips: "63830" },
    { name: "Kennett", zips: "63857" },
    { name: "Malden", zips: "63863" },
    { name: "Poplar Bluff", zips: "63901, 63902" },
    { name: "Jackson", zips: "63755" },
    { name: "Scott City", zips: "63780" },
    { name: "Chaffee", zips: "63740" },
    { name: "Cairo", zips: "62914" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Scott County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Bootheel Region Hub", desc: "Serving Sikeston, Charleston, New Madrid, and the Missouri Bootheel" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Cape Girardeau, MO", route: "/cities/cape-girardeau" },
    { name: "Fast passport renewal in St. Louis, MO", route: "/cities/st-louis" },
    { name: "Emergency passport help in Memphis, TN", route: "/cities/memphis" },
    { name: "Urgent passport services in Springfield, MO", route: "/cities/springfield-mo" },
    { name: "Passport courier services in Nashville, TN", route: "/cities/nashville" },
    { name: "Same-day passport help in Chicago, IL", route: "/cities/chicago" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Sikeston remotely via secure courier. We do not have a walk-in office in Sikeston — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Scott County, the Bootheel region, and southeast Missouri.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Scott County including Sikeston, Charleston, New Madrid, and the Missouri Bootheel region",
  serviceAreaIntro: "From the famous Lambert's Café and the historic Sikeston Depot & Museum to the rich cotton fields and agricultural lands of the Missouri Bootheel, from the Mississippi River communities of New Madrid and Charleston to the growing commercial hub of Sikeston at the crossroads of I-55 and I-57 — Fast Passport Center serves the entire southeast Missouri region. We regularly help Bootheel agricultural exporters, Mississippi River commerce travelers, and Scott County families get their passports fast without the long drive to Chicago, St. Louis, or Memphis.",
  nearbyCitiesIntro: "We serve all Sikeston neighborhoods and the surrounding area including Charleston, New Madrid, Dexter, and East Prairie. If you are anywhere in Scott County, New Madrid County, or the Missouri Bootheel, we have you covered.",
  howItWorksIntro: "Most Sikeston travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Sikeston travelers face significant distances to any regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Sikeston and Bootheel travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Sikeston? Here are the most common ones we hear from Bootheel travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/drivers/",
  dmvLabel: "Missouri DOR — Driver License Bureau",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Sikeston travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Bobby R.",
      location: "Sikeston, MO",
      rating: 5,
      text: "Cotton export deal in Brazil required last-minute trip. Fast Passport Center got my renewal in 26 hours. From the Bootheel to South America in 3 days. Sikeston agricultural community — this is the passport service you've been waiting for!",
      service: "Passport Renewal",
    },
    {
      name: "Cindy M.",
      location: "Charleston, MO",
      rating: 5,
      text: "Mississippi River cruise from New Orleans — realized my passport expired 5 days before departure. Fast Passport Center handled everything in 28 hours. Never left Scott County!",
      service: "Emergency Passport",
    },
    {
      name: "Tommy H.",
      location: "New Madrid, MO",
      rating: 5,
      text: "Family trip to Cancun and my son needed his first passport. Fast Passport Center walked us through the child process — 4 days start to finish. Bootheel families, this service is incredible!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "sikeston-1",
      name: "Sikeston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 S Kingshighway St",
      city: "Sikeston",
      state: "MO",
      zip: "63801",
      phone: "(573) 471-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Sikeston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Sikeston facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "sikeston-2",
      name: "Scott County Circuit Clerk",
      type: "County Government Passport Acceptance",
      address: "131 S Winchester St",
      city: "Benton",
      state: "MO",
      zip: "63736",
      phone: "(573) 545-3576",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "10 miles north of Sikeston",
      website: "https://www.scottcountymo.com",
      websiteLabel: "Scott County Circuit Clerk",
      notes: "Scott County seat in Benton with passport acceptance services. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "sikeston-3",
      name: "Cape Girardeau Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "320 N Frederick St",
      city: "Cape Girardeau",
      state: "MO",
      zip: "63701",
      phone: "(573) 334-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles north of Sikeston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major facility in Cape Girardeau. Full passport services available. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "sikeston-4",
      name: "Dexter Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "202 E Stoddard St",
      city: "Dexter",
      state: "MO",
      zip: "63841",
      phone: "(573) 624-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles west of Sikeston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Stoddard County area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "sikeston-5",
      name: "New Madrid Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "310 Main St",
      city: "New Madrid",
      state: "MO",
      zip: "63869",
      phone: "(573) 748-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles south of Sikeston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves New Madrid County area. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 6+ hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Sikeston photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Scott County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Sikeston and Bootheel applicants show up with incorrect payment and have to reschedule.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Bootheel families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Sikeston travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Sikeston." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Sikeston address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Sikeston before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Sikeston for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 6-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Sikeston?", a: "Fast Passport Center offers fast passport renewal in Sikeston in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Sikeston?", a: "The nearest regional passport agency to Sikeston is the Chicago Passport Agency, approximately 475 miles north via I-57. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Sikeston without any in-person agency visit required." },
    { q: "Do you serve the entire Missouri Bootheel region?", a: "Absolutely. Fast Passport Center serves the entire Missouri Bootheel region including Sikeston, Charleston, New Madrid, East Prairie, Portageville, Caruthersville, and Kennett. Our courier service works seamlessly from any address in Scott, New Madrid, Mississippi, or Pemiscot counties." },
    { q: "Can I get a same-day passport appointment near Sikeston?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — a 6+ hour drive from Sikeston — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Bootheel residents." },
    { q: "Do you serve Cape Girardeau and the SEMO area?", a: "Absolutely. Fast Passport Center serves the entire southeast Missouri region including Cape Girardeau, Jackson, Scott City, and the surrounding SEMO area. We provide expedited passport services to all Scott County and Cape Girardeau County residents." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Sikeston with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Can I expedite a child passport in Sikeston?", a: "Yes. Fast Passport Center expedites child passports in Sikeston for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Bootheel and Scott County families through the entire process." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Sikeston", address: "1401 S Main St, Sikeston, MO 63801", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Sikeston", address: "1002 S Main St, Sikeston, MO 63801", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Cape Girardeau", address: "3439 William St, Cape Girardeau, MO 63701", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walmart Supercenter — Dexter", address: "1803 W Business Highway 60, Dexter, MO 63841", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Sikeston License Office",
      address: "100 N Kingshighway St, Sikeston, MO 63801",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Most convenient for Sikeston and Scott County residents.",
      featured: true,
    },
    {
      name: "Missouri DOR — Cape Girardeau License Office",
      address: "3257 William St, Cape Girardeau, MO 63701",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Cape Girardeau County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Missouri DOR — Poplar Bluff License Office",
      address: "1900 N Westwood Blvd, Poplar Bluff, MO 63901",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Butler County and Bootheel region. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "CGI",
      name: "Cape Girardeau Regional Airport",
      distance: "30 miles north of Sikeston",
      address: "2300 N Airport Rd, Cape Girardeau, MO 63701",
      note: "Regional airport with connecting flights to Chicago and Nashville. About 35 minutes from Sikeston via I-55.",
      flightUrl: "https://www.capeairport.com/",
      flightLabel: "CGI Airport",
      featured: true,
    },
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "150 miles north of Sikeston",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major international airport with worldwide connections. About 2 hours 15 minutes from Sikeston via I-55.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: false,
    },
    {
      code: "MEM",
      name: "Memphis International Airport",
      distance: "140 miles south of Sikeston",
      address: "2491 Winchester Rd, Memphis, TN 38116",
      note: "Major international airport with FedEx global hub. About 2 hours from Sikeston via I-55.",
      flightUrl: "https://www.flymemphis.com/",
      flightLabel: "MEM Airport",
      featured: false,
    },
  ],
};